import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";

const parsePaymentNoticesFile = createAsyncThunk(
  "paymentNoticesList/parsePaymentNoticesFile",
  async (file: any, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const company = state.paymentNoticesList.accountSelected?.company;

      const formData = new FormData();
      formData.append("idCompany", company?.id + "");
      formData.append("file", file);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(`${api.baseURL}paymentNotice/parse-import-file`, {
        method: "POST",
        body: formData,
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default parsePaymentNoticesFile;
